import { Box } from '@mui/material';
import { AppState, deviceStoreSlice } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { Panel, Group as PanelGroup, Separator as PanelResizeHandle, PanelSize } from 'react-resizable-panels';
import { appStore } from '../../store';

export const ScanModeLayout = (props: {
    topChildren: React.ReactNode,
    leftChildren: React.ReactNode,
    topRightChildren: React.ReactNode,
    bottomRightChildren?: React.ReactNode,
    showBottomRightPanel: boolean,
}) => {


    const scanModeLayoutverticalSize = useSelector((state: AppState) => state.deviceStore.scanModeLayoutverticalSize);
    const scanModeLayoutHorizontalSize = useSelector((state: AppState) => state.deviceStore.scanModeLayoutHorizontalSize);
    const showBottomRightPanel = props.showBottomRightPanel && props.bottomRightChildren != null;

    const onVerticalResize = (panelSize: PanelSize) => {
        // Handle vertical resize logic here
        appStore.dispatch(deviceStoreSlice.actions.setScanModeLayoutVerticalSize(panelSize.asPercentage));
    };

    const onHorizontalResize = (panelSize: PanelSize) => {
        if (showBottomRightPanel) {
            appStore.dispatch(deviceStoreSlice.actions.setScanModeLayoutHorizontalSize(panelSize.asPercentage));
        }
    };

    return <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Box sx={{ height: 40, minHeight: 40, maxHeight: 40, display: 'flex', alignItems: 'center', px: 2 }}>
            {props.topChildren}
        </Box>
        <Box sx={{ position: 'absolute', top: 40, left: 0, right: 0, bottom: 0 }}>
            <PanelGroup orientation="horizontal">
                <Panel defaultSize={scanModeLayoutverticalSize ?? 50} minSize={30} onResize={onVerticalResize}>
                    <Box sx={{ height: '100%', overflowY: 'auto' }}>
                        {props.leftChildren}
                    </Box>
                </Panel>
                <PanelResizeHandle style={{ width: 6, backgroundColor: '#ccc' }} />
                <Panel defaultSize={100 - (scanModeLayoutverticalSize ?? 50)} minSize={30} >
                    <PanelGroup orientation="vertical">
                        <Panel defaultSize={showBottomRightPanel ? (scanModeLayoutHorizontalSize ?? 50) : 100} onResize={onHorizontalResize} minSize={30}>
                            <Box sx={{ height: '100%', overflowY: 'auto' }}>
                                {props.topRightChildren}
                            </Box>
                        </Panel>
                        {showBottomRightPanel && <>
                            <PanelResizeHandle style={{ height: 6, backgroundColor: '#ccc' }} />
                            <Panel defaultSize={100 - (scanModeLayoutHorizontalSize ?? 50)} minSize={30}>
                                <Box sx={{ height: '100%', overflowY: 'auto' }}>
                                    {props.bottomRightChildren}
                                </Box>
                            </Panel>
                        </>}
                    </PanelGroup>
                </Panel>
            </PanelGroup>
        </Box>
    </Box>;
};
